import common from './security-hero/common'
import assets from './security-hero/assets'
import MainScene from './security-hero/main-scene'
import mouseMng from './security-hero/mouse'
import Timeline from './security-hero/utils/timeline'
import {commonUniforms} from './security-hero/utils/common-uniforms'
import {observe} from '@github/selector-observer'

// import common from "./security-hero/Common";
// import assets from "./security-hero/Assets"
// import MainScene from "./security-hero/MainScene"
// import mouseMng from "./security-hero/MouseMng"
// import Timeline from "./security-hero/utils/Timeline";
// import {commonUniforms} from "./security-hero/utils/commonUniforms";

let mainScene: MainScene

let assetLoaded = false

observe('.js-security-hero', canvasElement => {
  const canvas = canvasElement as HTMLCanvasElement

  const canvasWrapper = document.querySelector('.lp-Hero-visual') as HTMLElement
  let animationFrameId: number | null = null

  common.init(canvasWrapper, canvas)
  mainScene = new MainScene()
  mouseMng.init()

  /**
   * Animate
   */

  let isVisible = true

  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        isVisible = true
        if (assetLoaded && animationFrameId === null) {
          init()
        } else {
          tick()
        }
      } else {
        isVisible = false
        pause()
      }
    }
  })

  observer.observe(canvasWrapper)

  const tick = () => {
    mouseMng.update()
    common.update()

    if (isVisible) {
      commonUniforms.uTime.value += common.delta * 1.25
      mainScene.update()
      mainScene.renderMainScene()
      mainScene.renderWholeScene()

      // Call tick again on the next frame
      animationFrameId = window.requestAnimationFrame(tick)
    }
  }

  const resize = () => {
    common.resize()
    mainScene.resize()
  }

  resize()

  const init = () => {
    mainScene.init()
    const timeline = new Timeline()

    timeline.to([commonUniforms.uLightIntensity], 1000, {value: 1}, 3000)
    timeline.start()
    assetLoaded = true

    tick()
  }

  const pause = () => {
    if (animationFrameId) window.cancelAnimationFrame(animationFrameId)

    mouseMng.update()
    common.update()
  }

  if (!assetLoaded) assets.load(init)

  // eslint-disable-next-line github/prefer-observers
  window.addEventListener('resize', resize)

  // eslint-disable-next-line github/prefer-observers
  window.addEventListener('scroll', () => {
    common.resize()
  })
})
